import React, { useEffect, useState } from "react";
import { Button, Modal, ModalDialog, Textarea } from '@mui/joy';
import { AddTaskBySyncApi } from "./function";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// TODO 행의 '+' → 하위 항목(하위 체크리스트) 추가 모달
// props: open, parent({ v2_id, content, v2_project_id, v2_section_id }), apiKey, handleClose, onSuccess
// 서버 /createTask 가 parentV2Id 를 받아 todo_tasks.parentId 에 저장 → 트리에서 부모의 subTasks 로 내려와 들여쓰기 표시됨.
// 상위/하위 완료 상태는 서로 연동하지 않는다(행 단위 독립).
const NewSubTaskModal: React.FC<any> = (props) => {

    const [description, setDescription] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    //열릴 때마다 입력 초기화
    useEffect(() => {
        if (props.open) setDescription("");
    }, [props.open]);

    const notify1 = () => toast.success("등록 성공!", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: true,
        theme: "colored"
    });

    const notifyError = () => toast.error("등록에 실패했습니다.", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored"
    });

    const parentTitle = (() => {
        var content: string = props.parent && props.parent.content ? String(props.parent.content) : "";
        if (content.startsWith("* ")) content = content.substring(2);
        if (content.length > 40) content = content.substring(0, 40) + "…";
        return content;
    })();

    const submit = async () => {

        if (!props.parent || !props.parent.v2_id || !props.parent.v2_project_id) return;
        if (!description.trim()) return;

        try {

            setLoading(true);

            const result: any = await AddTaskBySyncApi(
                description.trim(),
                props.parent.v2_project_id,
                props.parent.v2_section_id ? props.parent.v2_section_id : null,
                props.apiKey,
                props.parent.v2_id
            );

            setLoading(false);

            if (!result || result.message !== "success") {
                notifyError();
                return;
            }

            notify1();
            setDescription("");

            if (props.onSuccess) props.onSuccess();
            if (props.handleClose) props.handleClose();

        } catch (e) {
            console.log(e);
            setLoading(false);
            notifyError();
        }

    }

    return (
        <Modal open={!!props.open} onClose={() => {
            setDescription("");
            props.handleClose();
        }}>
            <ModalDialog>
                <div style={{ width: "400px" }}>
                    <div style={{ fontFamily: "Apple_B", fontSize: "18px", marginBottom: "24px", wordBreak: "break-all" }}>
                        [{parentTitle}] 하위 메뉴 추가하기
                    </div>

                    <div style={{ marginBottom: "12px", fontSize: "17px", fontFamily: "Apple_SB" }}>
                        전달사항
                    </div>
                    <div>
                        <Textarea minRows={2} autoFocus value={description} onChange={(e: any) => { setDescription(e.target.value) }} />
                    </div>

                    <div style={{ marginTop: "32px" }}>
                        <Button variant="solid" size="sm" fullWidth onClick={submit} loading={loading} disabled={!description.trim()}>
                            등록하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
}

export default NewSubTaskModal;
